// extracted by mini-css-extract-plugin
module.exports = {"resizer":"speakerNotes_resizer__1xbGt","speakerNotesContainer":"speakerNotes_speakerNotesContainer__w5Axb"};